import { useEffect, useState } from 'react';
import { NudosSelectButton } from '../../../../../components/NudosComponents';
import { IpermissionGroups, IuserPermissionsGroups } from '../../../../../types/configuration.types';
import { capitalize, changeNamingConvention } from '../../../../../utils/namingConventionsManagement';
import BordSelectDropdown from 'components/NudosComponents/BordSelectDropdown/BordSelectDropdown';
import './UserPermissionsGroupsDropdown.scss';

export interface IPermissionGroupDetail {
  id: number;
  name: string;
}
export type IPermissionGroupType = IPermissionGroupDetail[];

const UserPermissionsGroupDropdown = ({
  permissionGroups,
  currentPermissionGroups,
  updatePermissionGroupsCallback
}: {
  permissionGroups: IpermissionGroups;
  currentPermissionGroups: IuserPermissionsGroups[];
  updatePermissionGroupsCallback: (newPermissionGroups: number[]) => void;
}) => {
  const [userPermissionGroups, setUserPermissionGroups] = useState<number[]>([]);
  const [permissionGroupList, setPermissionGroupList] = useState<IPermissionGroupType>([]);
  const [permissionGroupCodeToNameMapping, setPermissionGrouopCodeToNameMapping] = useState<{ [key: string]: string }>(
    {}
  );

  const formatPermissionGroupOptions = () => {
    const permissionGroupList = Object.entries(permissionGroups).map(([groupName, data]) => {
      return {
        id: data.id,
        name: groupName
      };
    });
    const permissionGroupsMaping = permissionGroupList.reduce<{ [key: string]: string }>(
      (previousValue, currentValue) => {
        const updatedObject = { ...previousValue, [`${currentValue.id}`]: currentValue.name };
        return updatedObject;
      },
      {}
    );
    setPermissionGrouopCodeToNameMapping(permissionGroupsMaping);
    setPermissionGroupList(permissionGroupList);
  };

  const onChangeSelectedPermissionGroup = (permissionGroupOption: number) => {
    if (!permissionGroupOption) return;
    const existingPermissionGroups = [...userPermissionGroups];
    const permissionGroupOptionSelectionIndex = existingPermissionGroups.findIndex(
      savedPermissionGroup => savedPermissionGroup === permissionGroupOption
    );
    if (permissionGroupOptionSelectionIndex < 0) {
      const newPermissionGroups = [...userPermissionGroups, permissionGroupOption];
      setUserPermissionGroups(newPermissionGroups);
    } else {
      const newSelectedPermissionGroups = existingPermissionGroups.filter(
        savedPermissionGroup => savedPermissionGroup !== permissionGroupOption
      );
      setUserPermissionGroups(newSelectedPermissionGroups);
    }
  };

  const formatNameToDisplay = (rawName: string) => {
    const formatedName = changeNamingConvention(rawName, 'camel', 'kebab')?.replaceAll('-', ' ');
    return capitalize(formatedName);
  };

  const getUserPermissionGroupDropdownShowValue = () => {
    if (userPermissionGroups.length > 0) {
      const stringArr = userPermissionGroups.map(selectedUserPermissionGroup => {
        const permissionName = permissionGroupCodeToNameMapping[`${selectedUserPermissionGroup}`];
        return formatNameToDisplay(permissionName);
      });
      const userPermissionGroupsText = stringArr.join(', ');
      return userPermissionGroupsText;
    } else return 'Ej: admin';
  };

  const formOptionsUI = (rawPermissionGroupOptions: IPermissionGroupType | undefined): JSX.Element[] => {
    if (rawPermissionGroupOptions && rawPermissionGroupOptions.length > 0) {
      return rawPermissionGroupOptions.map((permissionGroupOption: IPermissionGroupDetail, i: number) => {
        const isCurrentlySelected = userPermissionGroups.some(
          (savedPermissionGroup, i) => savedPermissionGroup === permissionGroupOption.id
        );
        return (
          <div
            key={`permissionGroupOption${i}-${permissionGroupOption.id}`}
            className="permissionGroupOption"
            onClick={() => onChangeSelectedPermissionGroup(permissionGroupOption.id)}
          >
            <NudosSelectButton isButtonActive={isCurrentlySelected} colorPalette="black" />
            <div className="optionText">{formatNameToDisplay(permissionGroupOption.name)}</div>
          </div>
        );
      });
    } else {
      return [];
    }
  };

  useEffect(() => {
    formatPermissionGroupOptions();
  }, [permissionGroups]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const permissionGroupIds = currentPermissionGroups.map(group => group.permissionGroupId);
    setUserPermissionGroups(permissionGroupIds);
  }, [currentPermissionGroups]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    updatePermissionGroupsCallback(userPermissionGroups);
  }, [userPermissionGroups]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="userPermissionsGroupDropdown">
      <BordSelectDropdown
        label="Grupos del usuario"
        componentSize="medium"
        selectOptions={formOptionsUI(permissionGroupList)}
        currentValueOrplaceholder={getUserPermissionGroupDropdownShowValue()}
        isFilled={userPermissionGroups.length > 0}
        closesOnChangeSelection={false}
      />
    </div>
  );
};

export default UserPermissionsGroupDropdown;
